import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    templateUrl: "./server-error.html",
    encapsulation: ViewEncapsulation.None
})
export class ServerErrorPage {
}